export const CLIENT_FIELDS_EMPTY_NAME = 'Без названия';
